<template>
    <div class="live-page">
      <!-- 第一层：导航栏 -->
        <div @mouseenter="onMouseEnter" @mouseleave="onMouseLeave" style="height: 80px; position: fixed; top: 0; left: 0; right: 0; z-index: 100;">
            <NavBar @scroll-to="scrollTo" v-if="showNavBar" :selectedItem="selectedItem"/>
        </div>
  
      <!-- 第二层：介绍部分 -->
      <div class="live-intro">
        <!-- Tabs 部分 -->
        <div class="tabs">
          <button
            v-for="tab in tabs"
            :key="tab"
            :class="{ active: selectedTab === tab }"
            @click="selectTab(tab)"
          >
            {{ tab }}
          </button>
        </div>
  
        <!-- 照片展示部分 -->
        <div class="photo-grid">
          <div v-for="(column, index) in columns" :key="index" class="photo-column">
            <div class="column-top"></div>
            <div class = "album" v-for="(photo, photoIndex) in column" :key="photoIndex">
              <div class = "album-top"></div>
              <div class = "album-middle" @load="adjustPhotoSize($event)" >
                <div class = "album-left">LE-TIMES</div>
                <img 
                  v-lazy="photo" 
                  :alt="`Photo ${photoIndex}`" 
                  class="photo" 
                  
                  
                />
                <div class = "album-right">>> {{ selectedTab }}</div>
              </div>
              <div class = "album-bottom"></div>
            </div>
          </div>
        </div>
    
      </div>
    </div>
  </template>
  
  <script>
  import NavBar from './NavBar.vue';
  
  export default {
    components: {
      NavBar
    },
    data() {
        return {
            showNavBar: true,
            selectedItem:"OurBusiness",
            tabs: ["BAND", "DJ", "MUSICIAN", "PARADE", "DANCER"],
            selectedTab: "BAND",
            columns: [[], [], [], []], // 四列布局
            images: {
                BAND: [
                  require('@/assets/Live/Band/image_1.jpg'),
                  require('@/assets/Live/Band/image_2.jpg'),
                  require('@/assets/Live/Band/image_3.jpg'),
                  require('@/assets/Live/Band/image_4.jpg'),
                  require('@/assets/Live/Band/image_5.jpg'),
                  require('@/assets/Live/Band/image_6.jpg'),
                  require('@/assets/Live/Band/image_7.jpg'),
                  require('@/assets/Live/Band/image_8.jpg'),
                  require('@/assets/Live/Band/image_9.jpg'),
                  require('@/assets/Live/Band/image_10.jpg'),
                  require('@/assets/Live/Band/image_11.jpg'),
                  require('@/assets/Live/Band/image_12.jpg'),
                  require('@/assets/Live/Band/image_13.jpg'),
                  require('@/assets/Live/Band/image_14.jpg'),
                  require('@/assets/Live/Band/image_15.jpg'),
                  require('@/assets/Live/Band/image_16.jpg'),
                  require('@/assets/Live/Band/image_17.jpg'),
                  // require('@/assets/Live/Band/image_18.jpg'),
                  require('@/assets/Live/Band/image_19.jpg'),
                  require('@/assets/Live/Band/image_20.jpg'),
                  require('@/assets/Live/Band/image_21.jpg'),
                  require('@/assets/Live/Band/image_22.jpg'),
                  require('@/assets/Live/Band/image_23.jpg'),
                  require('@/assets/Live/Band/image_24.jpg'),
                  require('@/assets/Live/Band/image_25.jpg'),
                  require('@/assets/Live/Band/image_26.jpg'),
                  require('@/assets/Live/Band/image_27.jpg'),
                  require('@/assets/Live/Band/image_28.jpg'),
                  require('@/assets/Live/Band/image_29.jpg'),
                  require('@/assets/Live/Band/image_30.jpg'),
                  require('@/assets/Live/Band/image_31.jpg'),
                  require('@/assets/Live/Band/image_32.jpg'),
                  require('@/assets/Live/Band/image_33.jpg'),
                  require('@/assets/Live/Band/image_34.jpg'),
                  require('@/assets/Live/Band/image_35.jpg'),
                  require('@/assets/Live/Band/image_36.jpg'),
                  require('@/assets/Live/Band/image_37.jpg'),
                  require('@/assets/Live/Band/image_38.jpg'),
                  require('@/assets/Live/Band/image_39.jpg'),
                  require('@/assets/Live/Band/image_40.jpg'),
                  require('@/assets/Live/Band/image_41.jpg'),
                  require('@/assets/Live/Band/image_42.jpg'),
                  require('@/assets/Live/Band/image_43.jpg'),
                ],
                DJ: [
                  require('@/assets/Live/DJ/image_1.jpg'),
                  require('@/assets/Live/DJ/image_2.jpg'),
                  require('@/assets/Live/DJ/image_3.jpg'),
                  require('@/assets/Live/DJ/image_4.jpg'),
                  require('@/assets/Live/DJ/image_5.jpg'),
                  require('@/assets/Live/DJ/image_6.jpg'),
                  require('@/assets/Live/DJ/image_7.jpg'),
                  require('@/assets/Live/DJ/image_8.jpg'),
                  require('@/assets/Live/DJ/image_9.jpg'),
                  require('@/assets/Live/DJ/image_10.jpg'),
                  require('@/assets/Live/DJ/image_11.jpg'),
                ],
                MUSICIAN: [
                  require('@/assets/Live/Musician/image_1.jpg'),
                  require('@/assets/Live/Musician/image_2.jpg'),
                  require('@/assets/Live/Musician/image_3.jpg'),
                  require('@/assets/Live/Musician/image_4.jpg'),
                  require('@/assets/Live/Musician/image_5.jpg'),
                  require('@/assets/Live/Musician/image_6.jpg'),
                  require('@/assets/Live/Musician/image_7.jpg'),
                  require('@/assets/Live/Musician/image_8.jpg'),
                  require('@/assets/Live/Musician/image_9.jpg'),
                  require('@/assets/Live/Musician/image_10.jpg'),
                  require('@/assets/Live/Musician/image_11.jpg'),
                  require('@/assets/Live/Musician/image_12.jpg'),
                  require('@/assets/Live/Musician/image_13.jpg'),
                  require('@/assets/Live/Musician/image_14.jpg'),
                  require('@/assets/Live/Musician/image_15.jpg'),
                  require('@/assets/Live/Musician/image_16.jpg'),
                  require('@/assets/Live/Musician/image_17.jpg'),
                  require('@/assets/Live/Musician/image_18.jpg'),
                  require('@/assets/Live/Musician/image_19.jpg'),
                  require('@/assets/Live/Musician/image_20.jpg'),
                  require('@/assets/Live/Musician/image_21.jpg'),
                  require('@/assets/Live/Musician/image_22.jpg'),
                  require('@/assets/Live/Musician/image_23.jpg'),
                  require('@/assets/Live/Musician/image_24.jpg'),
                  require('@/assets/Live/Musician/image_25.jpg'),
                  require('@/assets/Live/Musician/image_26.jpg'),
                  require('@/assets/Live/Musician/image_27.jpg'),
                  require('@/assets/Live/Musician/image_28.jpg'),
                  require('@/assets/Live/Musician/image_29.jpg'),
                ],
                PARADE: [
                  require('@/assets/Live/Parade/image_1.jpg'),
                  require('@/assets/Live/Parade/image_2.jpg'),
                  require('@/assets/Live/Parade/image_3.jpg'),
                  require('@/assets/Live/Parade/image_4.jpg'),
                  require('@/assets/Live/Parade/image_5.jpg'),
                  require('@/assets/Live/Parade/image_6.jpg'),
                  require('@/assets/Live/Parade/image_7.jpg'),
                  require('@/assets/Live/Parade/image_8.jpg'),
                  require('@/assets/Live/Parade/image_9.jpg'),
                  require('@/assets/Live/Parade/image_10.jpg'),
                  require('@/assets/Live/Parade/image_11.jpg'),
                  // require('@/assets/Live/Parade/image_12.jpg'),
                  require('@/assets/Live/Parade/image_13.jpg'),
                  require('@/assets/Live/Parade/image_14.jpg'),
                  require('@/assets/Live/Parade/image_15.jpg'),
                  require('@/assets/Live/Parade/image_16.jpg'),
                  require('@/assets/Live/Parade/image_17.jpg'),
                  require('@/assets/Live/Parade/image_18.jpg'),
                  require('@/assets/Live/Parade/image_19.jpg'),
                  require('@/assets/Live/Parade/image_20.jpg'),
                  require('@/assets/Live/Parade/image_21.jpg'),
                  require('@/assets/Live/Parade/image_22.jpg'),
                  require('@/assets/Live/Parade/image_23.jpg'),
                ],
                DANCER: [
                  require('@/assets/Live/Dancer/image_1.jpg'),
                  require('@/assets/Live/Dancer/image_2.jpg'),
                  require('@/assets/Live/Dancer/image_3.jpg'),
                  require('@/assets/Live/Dancer/image_4.jpg'),
                  require('@/assets/Live/Dancer/image_5.jpg'),
                  require('@/assets/Live/Dancer/image_6.jpg'),
                  require('@/assets/Live/Dancer/image_7.jpg'),
                  require('@/assets/Live/Dancer/image_8.jpg'),
                  require('@/assets/Live/Dancer/image_9.jpg'),
                  require('@/assets/Live/Dancer/image_10.jpg'),
                  require('@/assets/Live/Dancer/image_11.jpg'),
                  require('@/assets/Live/Dancer/image_12.jpg'),
                  require('@/assets/Live/Dancer/image_13.jpg'),
                  require('@/assets/Live/Dancer/image_14.jpg'),
                  require('@/assets/Live/Dancer/image_15.jpg'),
                  require('@/assets/Live/Dancer/image_16.jpg'),
                ]
            }
        }
    },
    methods: {
        printname(name){
          console.log(name)
        },
        onMouseEnter() {
                this.showNavBar = true;
            },
        onMouseLeave() {
            this.showNavBar = true;
        },
        scrollTo(refName) {
            const component = this.$refs[refName];
            if (component && component.$el) {
            component.$el.scrollIntoView({ behavior: 'smooth' });
            }
        },
        handleNavigation(id) {
            this.$router.push({ name: id });
            console.log("Handling navigation to:", id);
        },
        selectTab(tab) {
            this.selectedTab = tab;
            this.loadPhotos();
        },
        loadPhotos() {
            const photos = this.images[this.selectedTab]; // 获取选中 tab 对应的图片列表
            // 根据屏幕宽度调整列数
            const columnCount = window.innerWidth < 768 ? 2 : 4;
            
            // 初始化列数
            this.columns = Array.from({ length: columnCount }, () => []);

            // 将照片分配到列中
            photos.forEach((photo, index) => {
                this.columns[index % columnCount].push(photo);
            });
        },
        adjustPhotoSize(event) {
          const img = event.target;
          const aspectRatio = img.naturalHeight / img.naturalWidth;
          img.style.height = `${img.offsetWidth * aspectRatio}px`;
          console.log(img.style.height)
        }
    },
    mounted() {
      this.loadPhotos(); // 默认加载 band 的照片
      window.addEventListener("resize", this.loadPhotos);
    },
    beforeUnmount() {
        // 移除事件监听器以防止内存泄漏
        window.removeEventListener("resize", this.loadPhotos);
    },
  };
  </script>
  
  <style scoped>
  .live-page {
    background: url(../assets/backgroundpure.png) no-repeat center center;
    background-size: cover;
    z-index: -1; /* 确保背景位于内容之下 */
    width:100vw;
    height: 100vh;

  }
  
  .live-intro {
    padding: 20px;
    background-color: rgba(0,0,0,0.5);
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center; /* 水平居中 */
    width:100vw;
    height:auto;
  }
  
  .tabs {
    display: flex;
    flex-direction: row;
    align-items: center;
    height: 80px;
    width: 85%;
    justify-content: space-between;
    margin-top: 80px;
    margin-bottom: 16px;
  }
  
  .tabs button {
    height: 64px;
    width:19%;
    cursor: pointer;
    color:#FFFFFF;
    background-color: rgba(47, 47, 47, 0.467);
    border: 0px;
    font-size: 1rem;
    box-shadow: 0 4px 4px 0 rgba(0, 0, 0, 0.5), 0 6px 20px 0 rgba(0, 0, 0, 0.5);
  }
  
  .tabs .active {
    color:rgba(56, 48, 31);
    /* background: linear-gradient(90deg, #BAA273, rgba(81, 69, 46, 0.85)); */
    background-image: linear-gradient( 109.9deg,  rgba(251,189,100,1) 1.8%, rgba(255,207,139,1) 95.4% );
    /*background-color: #BAA273;*/
    border: 0px;
    font-size: 1.2rem;
    box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.5), 0 6px 20px 0 rgba(0, 0, 0, 0.5);
  }
  .tabs button:hover {
    /* background:linear-gradient(90deg,  rgba(81, 69, 46, 0.85),rgba(186, 162, 115, 0.85));  */
    background-image: linear-gradient(  rgba(255,207,139,1),  rgba(251,189,100,1));
    color:black;
}
  
  .photo-grid {
    display: flex;
    justify-content: center; /* 水平居中 */
    gap: 32px;
    width: 85%;
    height: 100%;
    /*overflow-y: scroll; 启用垂直滚动 */
  }
  .column-top{
  width:100%;
  height: 8px;
  background-color: black;
}
  .photo-column {
    flex: 1;
    display: flex;
    flex-direction: column;
    gap: 0px;
    box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.5), 0 6px 20px 0 rgba(0, 0, 0, 0.5);
  }
  .album-top{
    width: 100%;
    height: 8px;
    background-color: black
  }
  .album-middle{
    display: flex;
    flex-direction: row;
    background-color: black;
    justify-content: center;
    /* align-items: center; */
  }
  .album-bottom{
    background-color: black;
    width:100%;
    height: 8px;
  }
  .album-left{
    background-color: black;
    width: 32px;
    color: rgb(220, 220, 220);
    font-size: 0.6rem;
    /* transform: rotate(90deg); */
    writing-mode: vertical-lr;
    /* width: fit-content; */
    /* writing-mode: vertical-rl; */
    
    text-align: end;
    line-height: 32px;
  }
  .album-right{
    background-color: black;
    width: 32px;
    
    color: rgb(220, 220, 220);
    font-size: 0.6rem;
    /* transform: rotate(90deg); */
    writing-mode: vertical-lr;
    text-align: start;
    line-height: 32px;
  }
  .photo {
    width: 100%;
    object-fit: cover;
    border-radius: 0px;
  }
  @media (max-width: 768px) {
        .photo-grid {
            display: grid;
            grid-template-columns: repeat(2, 1fr); /* 使用两列布局 */
            gap: 8px;
            width:95%;
            height: auto;
        }
        .tabs{
          margin-top: 48px;
          width:95%;
        }
        .tabs button {
          height: 48px;
        }
        .album-left{
          width:4px;
        }
        .album-right{
          width:4px;
        }
    }
  </style>
 